import { render, staticRenderFns } from "./LangDropdown.vue?vue&type=template&id=e6a82d14&"
import script from "./LangDropdown.ts?vue&type=script&lang=ts&"
export * from "./LangDropdown.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LangDropdown.vue"
export default component.exports